import { defineComponent as t, openBlock as o, createBlock as d, unref as r, withCtx as n, renderSlot as f } from "vue";
import s from "./ghl-ui.es261.js";
const i = t({
  name: "UICheckboxGroup",
  inheritAttrs: !1
}), p = t({
  ...i,
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    value: {
      type: [Array, null]
    },
    defaultValue: {
      type: [Array, null]
    }
  },
  emits: ["update:value"],
  setup(e) {
    return (a, l) => (o(), d(r(s), {
      disabled: e.disabled,
      "default-value": e.defaultValue,
      value: e.value,
      "onUpdate:value": l[0] || (l[0] = (u) => a.$emit("update:value", u))
    }, {
      default: n(() => [
        f(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "default-value", "value"]));
  }
}), b = p;
export {
  b as default
};
